var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg30Opt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 800,
    viewBox: "0 -0.5 17 17",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    transform: "translate(-0.5,0.522)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.1 14.941H3.77v-3.834L5.693 7.78l4.606 2.66-1.2 2.129Z",
    style: {
      fill: "#000000",
      stroke: "#000000",
      strokeWidth: 0.02125
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg30Opt);
export default __webpack_public_path__ + "static/media/30_opt.d5e396e1b9c2e807eddfb219ded80f45.svg";
export { ForwardRef as ReactComponent };